export default [
  {
    type: "title",
    label: "1. 안전보건 목표와 경영방침의 설정",
    text1: "연간",
    text2: "1",
    text3: "5",
    text4: "5",
  },
  {
    id: 1,
    label: "목표",
    text1: "목표",
    text2: "-",
    text3: "2",
    text4: "",
    maxScore: 2,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 2,
    label: "방침",
    text1: "방침",
    text2: "-",
    text3: "3",
    text4: "",
    maxScore: 3,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    type: "title",
    label: "2. 안전･보건 업무를 총괄･관리하는 전담 조직 설치",
    text1: "최초",
    text2: "변경 시",
    text3: "5",
    text4: "5",
  },
  {
    id: 3,
    label: "안전･보건 업무를 총괄･관리하는 전담 조직 설치",
    text1: "-",
    text2: "-",
    text3: "5",
    text4: "",
    maxScore: 5,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    type: "title",
    titleColor: "#4839EB",
    label: "3. 유해･위험요인 확인 개선 절차 마련, 점검 및 필요한 조치",
    text1: "반기",
    text2: "1",
    text3: "10",
    text4: "10",
  },
  {
    id: 4,
    label: "절차서",
    text1: "-",
    text2: "-",
    text3: "1.5",
    text4: "",
    maxScore: 1.5,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 5,
    label: "안전보건정보 사전조사",
    text1: "-",
    text2: "-",
    text3: "1.5",
    text4: "",
    maxScore: 1.5,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 6,
    label: "위험성평가협의회",
    text1: "-",
    text2: "-",
    text3: "2",
    text4: "",
    maxScore: 2,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 7,
    label: "유해·위험요인 파악",
    text1: "-",
    text2: "-",
    text3: "2",
    text4: "",
    maxScore: 2,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 8,
    label: "정기위험성평가",
    text1: "-",
    text2: "-",
    text3: "3",
    text4: "",
    maxScore: 3,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    type: "title",
    titleColor: "#E42728",
    label: "■ 가점(Part-1)",
    text1: "-",
    text2: "-",
    text3: "10",
    text4: "8.5",
  },
  {
    id: 9,
    type: "addPoint",
    label: "수시위험성평가",
    text1: "수시",
    text2: "가중치",
    text3: "1.5",
    text4: "",
    maxScore: 1.5,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 10,
    type: "addPoint",
    label: "아차사고 등록",
    text1: "수시",
    text2: "가중치",
    text3: "1.5",
    text4: "",
    maxScore: 1.5,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 11,
    type: "addPoint",
    label: "3등급(상·중·하) 판단법",
    text1: "월간",
    text2: "가중치",
    text3: "2",
    text4: "",
    maxScore: 2,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 12,
    type: "addPoint",
    label: "주간 이행사항 점검 및 회의",
    text1: "주간",
    text2: "가중치",
    text3: "2",
    text4: "",
    maxScore: 2,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 13,
    type: "addPoint",
    label: "일일TBM 활동",
    text1: "일일",
    text2: "가중치",
    text3: "3",
    text4: "",
    maxScore: 3,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    type: "title",
    titleColor: "#E42728",
    label: "■ 가점(Part-2)",
    text1: "-",
    text2: "-",
    text3: "10",
    text4: "8.5",
  },
  {
    id: 14,
    type: "addPoint",
    label: "교육(정기, 특별, 채용시, MSDS)",
    text1: "수시",
    text2: "가중치",
    text3: "1.5",
    text4: "",
    maxScore: 1.5,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 15,
    type: "addPoint",
    label: "유해·위험 기계·기구 설비 점검",
    text1: "분기",
    text2: "가중치",
    text3: "1.5",
    text4: "",
    maxScore: 1.5,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 16,
    type: "addPoint",
    label: "합동점검",
    text1: "분기",
    text2: "가중치",
    text3: "2",
    text4: "",
    maxScore: 2,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 17,
    type: "addPoint",
    label: "순회점검",
    text1: "2일",
    text2: "가중치",
    text3: "2",
    text4: "",
    maxScore: 2,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 18,
    type: "addPoint",
    label: "일상점검",
    text1: "일일",
    text2: "가중치",
    text3: "3",
    text4: "",
    maxScore: 3,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    type: "title",
    titleColor: "#4839EB",
    label: "4. 안전･보건에 관한 인력･시설･장비 구비와 유해･위험요인 개선 예산 편성 및 집행",
    text1: "-",
    text2: "-",
    text3: "10",
    text4: "10",
  },
  {
    id: 19,
    label: "편성 여부",
    text1: "편성 여부",
    text2: "있음 or 없음",
    text3: "4",
    text4: "",
    maxScore: 4,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 20,
    label: "집행 건수",
    text1: "집행 건수",
    text2: "건수",
    text3: "6",
    text4: "",
    maxScore: 6,
    scoreType: "건수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    type: "title",
    titleColor: "#4839EB",
    label: "5. 안전보건관리책임자등의 충실한 업무수행 지원",
    text1: "-",
    text2: "-",
    text3: "10",
    text4: "10",
  },
  {
    id: 21,
    label: "<span style='color:#E42728'>디지털 안전·보건관리 시스템</span>",
    text1: "-",
    text2: "있음 or 없음",
    text3: "5",
    text4: "",
    maxScore: 5,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 22,
    label: "법무법인(유한) 대륙아주 준수 인증제(SCC)",
    text1: "-",
    text2: "있음 or 없음",
    text3: "2",
    text4: "",
    maxScore: 2,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 23,
    label: "위험성평가 컨설팅",
    text1: "-",
    text2: "있음 or 없음",
    text3: "2",
    text4: "",
    maxScore: 2,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 24,
    label: "KOSHA MS, ISO45001",
    text1: "-",
    text2: "있음 or 없음",
    text3: "1",
    text4: "",
    maxScore: 1,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    type: "title",
    label: "6. 산업안전보건법에 따른 안전관리자, 보건관리자 등 전문인력 배치",
    text1: "-",
    text2: "-",
    text3: "5",
    text4: "5",
  },
  {
    id: 25,
    label: "자체 조직 구성",
    text1: "-",
    text2: "있음 or 없음",
    text3: "2",
    text4: "",
    maxScore: 2,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 26,
    label: "안전전문기관 대행",
    text1: "-",
    text2: "있음 or 없음",
    text3: "1",
    text4: "",
    maxScore: 1,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 27,
    label: "보건전문기관 대행",
    text1: "-",
    text2: "있음 or 없음",
    text3: "1",
    text4: "",
    maxScore: 1,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 28,
    label: "산업보건의 선임",
    text1: "-",
    text2: "있음 or 없음",
    text3: "1",
    text4: "",
    maxScore: 1,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    type: "title",
    label: "7. 종사자 의견 청취 절차마련, 청취 및 개선방안 마련･이행 여부 점검",
    text1: "-",
    text2: "-",
    text3: "5",
    text4: "5",
  },
  {
    id: 29,
    label: "절차 마련 (계절별)<span style='color:#E42728'> > 0.5점씩 부여</span>",
    text1: "계절별",
    text2: "있음 or 없음",
    text3: "2",
    text4: "",
    maxScore: 2,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 30,
    label: "점검 현황",
    text1: "점검 현황",
    text2: "<span style='color:#4839EB'>건수</span>",
    text3: "3",
    text4: "",
    maxScore: 3,
    scoreType: "건수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    type: "title",
    titleColor: "#4839EB",
    label: "8. 중대산업재해 발생 시 등 조치 매뉴얼 마련 및 조치 여부 점검",
    text1: "-",
    text2: "-",
    text3: "10",
    text4: "10",
  },
  {
    id: 31,
    label: "<span style='font-weight: 500'>(1) (중대)산업재해 발생 시 보고 절차</span>",
    isNoBeforeIcon: true,
    text1: "절차 마련",
    text2: "있음 or 없음",
    text3: "1",
    text4: "",
    maxScore: 1,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    label: "<span style='font-weight: 500'>(2) 비상조치 처리 절차</span>",
    isNoBeforeIcon: true,
  },
  {
    id: 32,
    label: "➀ 상황별 비상 대비 시나리오",
    text1: "시나리오 마련",
    text2: "있음 or 없음",
    text3: "0.5",
    text4: "",
    maxScore: 0.5,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 33,
    label: "➁ 사고별·시간별 시나리오",
    text1: "시나리오 마련",
    text2: "있음 or 없음",
    text3: "0.5",
    text4: "",
    maxScore: 0.5,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 34,
    label: "<span style='font-weight: 500'>(3) 비상조치계획 수립</span>",
    isNoBeforeIcon: true,
    text1: "계획 마련",
    text2: "있음 or 없음",
    text3: "1",
    text4: "",
    maxScore: 1,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    label: "<span style='font-weight: 500'>(4) 비상대피 훈련·교육·평가</span>",
    isNoBeforeIcon: true,
  },
  {
    id: 35,
    label: "➀ 훈련",
    text1: "훈련",
    text2: "있음 or 없음",
    text3: "0.4",
    text4: "",
    maxScore: 0.4,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 36,
    label: "➁ 교육",
    text1: "교육",
    text2: "있음 or 없음",
    text3: "0.4",
    text4: "",
    maxScore: 0.4,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 37,
    label: "➂ 평가",
    text1: "평가",
    text2: "있음 or 없음",
    text3: "0.2",
    text4: "",
    maxScore: 0.2,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 38,
    label: "조치 현황",
    isNoBeforeIcon: true,
    text1: "조치 현황",
    text2: "건수",
    text3: "6",
    text4: "",
    maxScore: 6,
    scoreType: "건수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    type: "title",
    label: "9. 도급, 용역, 위탁 시 평가기준･절차 및 관리비용, 업무수행기관 관련 기준 마련･이행 여부 점검",
    text1: "-",
    text2: "-",
    text3: "5",
    text4: "5",
  },
  {
    id: 39,
    label: "기준 마련",
    text1: "기준 마련",
    text2: "있음 or 없음",
    text3: "2",
    text4: "",
    maxScore: 2,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 40,
    label: "점검 현황",
    text1: "점검 현황",
    text2: "<span style='color:#4839EB'>건수</span>",
    text3: "3",
    text4: "",
    maxScore: 3,
    scoreType: "건수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    type: "title",
    titleColor: "#4839EB",
    label: "10. 재해 발생 시 재발방지 대책의 수립 및 그 이행에 관한 조치",
    text1: "-",
    text2: "-",
    text3: "10",
    text4: "10",
  },
  {
    id: 41,
    label: "대책 수립",
    text1: "대책 수립",
    text2: "있음 or 없음",
    text3: "4",
    text4: "",
    maxScore: 4,
    scoreType: "여부",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 42,
    label: "점검 현황",
    text1: "점검 현황",
    text2: "<span style='color:#4839EB'>건수</span>",
    text3: "6",
    text4: "",
    maxScore: 6,
    scoreType: "건수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    type: "title",
    label: "11. 중앙행정기관･지방자치단체 등의 개선, 시정 조치",
    text1: "-",
    text2: "-",
    text3: "5",
    text4: "5",
  },
  {
    id: 43,
    label: "지적 여부",
    text1: "지적 여부",
    text2: "없음 or 있음",
    text3: "2",
    text4: "",
    maxScore: 2,
    scoreType: "여부 R",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    id: 44,
    label: "지적 현황",
    text1: "지적 현황",
    text2: "<span style='color:#E42728'>건수</span>",
    text3: "3",
    text4: "",
    maxScore: 3,
    scoreType: "건수 R",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
  {
    type: "title",
    titleColor: "#4839EB",
    label: "12. 안전･보건관계 법령에 따른 의무이행에 필요한 관리상의 조치(법 제4조제1항제4호)",
    text1: "-",
    text2: "-",
    text3: "10",
    text4: "10",
  },
  {
    id: 45,
    label: "디지털 안전·보건관리 시스템 운영 담당자 지정",
    text1: "<span style='color:#E42728'>지정 여부</span>",
    text2: "-",
    text3: "10",
    text4: "",
    maxScore: 10,
    scoreType: "점수",
    endColumn: [
      { id : 1, type: 'input', content: "", },
    ],
  },
];
